import { __awaiter, __generator } from "tslib";
import { useEffect } from 'react';
import { useUtility } from '../utilityReactProvider';
export var useAuthMethods = function () {
    var _a = useUtility(), Auth0 = _a.Auth0, Organizations = _a.Organizations, Hubspot = _a.Hubspot, UserProfile = _a.UserProfile;
    useEffect(function () {
        if (!Auth0) {
            throw new Error('The Utility provided does not include Auth0 module, ensure you are using the right version');
        }
        if (!Hubspot) {
            throw new Error('The Utility provided does not include Hubspot module, ensure you are using the right version');
        }
        if (!UserProfile) {
            throw new Error('The Utility provided does not include UserProfile module, ensure you are using the right version');
        }
    }, []);
    var refreshOrganizations = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!Organizations) {
                        throw new Error('The Utility provided does not include Organizations module, ensure you are using the right version');
                    }
                    return [4 /*yield*/, Organizations.getOrganizations()];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var logout = function (options) {
        Auth0.logout(options);
        UserProfile.clearUserProfile();
    };
    var postLoginProcess = function () { return __awaiter(void 0, void 0, void 0, function () {
        var userProfile, activeOrg;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    UserProfile.clearUserProfile();
                    return [4 /*yield*/, UserProfile.getUserProfile()];
                case 1:
                    userProfile = _a.sent();
                    if (!(((userProfile === null || userProfile === void 0 ? void 0 : userProfile.self_register) && (userProfile === null || userProfile === void 0 ? void 0 : userProfile.email_verified)) || !(userProfile === null || userProfile === void 0 ? void 0 : userProfile.self_register))) return [3 /*break*/, 4];
                    return [4 /*yield*/, refreshOrganizations()];
                case 2:
                    _a.sent();
                    activeOrg = Organizations.getActiveOrganization();
                    if (!(!!activeOrg && !!userProfile && !activeOrg.self_register)) return [3 /*break*/, 4];
                    return [4 /*yield*/, Hubspot.initHubspot()];
                case 3:
                    _a.sent();
                    _a.label = 4;
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var login = function (email, password) {
        return Auth0.login(email, password).then(function (result) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, postLoginProcess()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, result];
                }
            });
        }); });
    };
    /* istanbul ignore next - TODO: add coverage */
    var checkSession = function (refreshOrgs) { return __awaiter(void 0, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Auth0.checkSession({
                        redirectUri: window.location.origin,
                    })];
                case 1:
                    result = _a.sent();
                    if (!refreshOrgs) return [3 /*break*/, 3];
                    return [4 /*yield*/, refreshOrganizations()];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3: 
                // Note: we cannot initiate Hubspot until the POST /user request has been made
                // Since GET /hubspot/visitors expects an accessToken AND a Didomi user
                return [2 /*return*/, result];
            }
        });
    }); };
    var parseSsoHash = function (hash, refreshOrgs) { return __awaiter(void 0, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Auth0.parseSsoHash(hash)];
                case 1:
                    result = _a.sent();
                    if (!refreshOrgs) return [3 /*break*/, 3];
                    return [4 /*yield*/, refreshOrganizations()];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3: 
                // Note: we cannot initiate Hubspot until the POST /user request has been made
                // Since GET /hubspot/visitors expects an accessToken AND a Didomi user
                return [2 /*return*/, result];
            }
        });
    }); };
    return {
        postLoginProcess: postLoginProcess,
        login: login,
        logout: logout,
        setToken: Auth0 === null || Auth0 === void 0 ? void 0 : Auth0.setToken,
        resetPassword: Auth0 === null || Auth0 === void 0 ? void 0 : Auth0.resetPassword,
        getUserProfile: Auth0 === null || Auth0 === void 0 ? void 0 : Auth0.getUserProfile,
        isAuthenticated: Auth0 === null || Auth0 === void 0 ? void 0 : Auth0.isAuthenticated,
        socialSsoLogin: Auth0 === null || Auth0 === void 0 ? void 0 : Auth0.socialSsoLogin,
        parseSsoHash: parseSsoHash,
        checkSession: checkSession,
    };
};
